const ConversationRoutes = {
  createConversation: 'admin/gpt/conversation/create',
  getMessages: 'admin/gpt/talktokrissai',
  sendMessage: 'admin/gpt/talktokrissai',
  getConversationList: 'admin/gpt/conversation/list',
};

export default ConversationRoutes